import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Role } from '../../model/enum/role';
import { LocalStorageService } from '../../shared/services/local-storage.service';

export const roleGuard: CanActivateFn = (route, _) => {
  const router = inject(Router);
  const localStorage = inject(LocalStorageService);

  const requiredRoles: Role[] = route.data['roles'] ?? [];
  const role = localStorage.getRole();

  if (!role) {
    return false;
  }

  const hasAccess =
    requiredRoles.length === 0 || requiredRoles.includes(role);

  if (!hasAccess) {
    return router.parseUrl('/401');
  }

  return true;
};
